import { render, staticRenderFns } from "./linkMenu.vue?vue&type=template&id=501fe93e&"
import script from "./linkMenu.vue?vue&type=script&lang=js&"
export * from "./linkMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports